var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShopping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 1018 1018",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M317.822 953.466c35.106 0 63.565-28.459 63.565-63.564 0-35.106-28.459-63.565-63.565-63.565-35.105 0-63.564 28.459-63.564 63.565 0 35.105 28.459 63.564 63.564 63.564zM762.773 953.466c35.106 0 63.564-28.459 63.564-63.564 0-35.106-28.458-63.565-63.564-63.565s-63.565 28.459-63.565 63.565c0 35.105 28.459 63.564 63.565 63.564zM889.902 222.474h-704.93L158.911 88.989a31.784 31.784 0 00-31.782-25.426H0v63.565h101.067l121.408 610.218a31.781 31.781 0 0031.783 25.426h572.079v-63.565H280.319l-26.061-127.129h572.079a31.78 31.78 0 0031.782-24.79l63.565-286.04a31.775 31.775 0 00-6.422-27.149 31.785 31.785 0 00-25.36-11.625zm-88.991 286.04H242.18l-44.495-222.475h652.489l-49.263 222.475z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShopping);
export default __webpack_public_path__ + "static/media/iconShopping.745aecef3846598c54f2310272c9d367.svg";
export { ForwardRef as ReactComponent };